<template>
  <NuxtImg
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    :loading="loading"
    :style="style"
    :format="format"
    :fit="fit"
    v-bind="$attrs"
    @error="onError"
    referrerpolicy="no-referrer"
  />
</template>

<script setup lang="ts">
  interface Props {
    src: string | undefined;
    alt: string;
    width?: string | number | undefined;
    height?: string | number | undefined;
    loading?: 'lazy' | 'eager';
    style?: Record<string, string>;
    format?: 'svg' | 'webp' | 'avif' | 'png' | 'jpg' | 'jpeg' | 'gif';
    placeholder?: string;
    fit?: 'inside' | 'outside' | 'cover' | 'contain' | 'fill';
  }

  const props = withDefaults(defineProps<Props>(), {
    loading: 'lazy',
    format: 'webp',
    style: () => ({}),
    width: undefined,
    height: undefined,
    placeholder: undefined,
    fit: 'cover'
  });

  const src = ref<string | undefined>(props.src);

  const onError = () => {
    src.value = props.placeholder;
  };
</script>
